import React, { useEffect, useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { ImageGalleryElement, StoryElement } from "@quintype/components";
import LightBoxGallery from "../../molecules/lightBox-gallery";
import LightBoxImage from "../../molecules/lightBox-image";
import GlideCarousel from "../../molecules/glide-carousel";
import { ResponsiveImage } from "@quintype/components";
import LazyEagerImage from "../../atoms/lazy-eager";
import AlsoRead from "../../molecules/also-read";
import { checkEmbedCode } from "../../utils/checkEmbed";
import "./story-card.m.css";

const StoryCard = ({ story, card, excludeElementId, cdnImage }) => {
  const [galleryItemIndex, setGalleryItemIndex] = useState(0);
  const [slideshowItems, setSlideshowItems] = useState([]);
  const [showGalleryPopup, setShowGalleryPopup] = useState({});
  const [showSingleImagePopup, setShowSingleImagePopup] = useState({});

  useEffect(() => {
    {
      story["story-template"] === "natiivi" && card["story-elements"].forEach(element => {

        if (element.text && element.text.includes('<a')) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = element.text;
          const anchors = tempDiv.querySelectorAll('a');
          anchors.forEach(anchor => {
            anchor.setAttribute('target', '_blank');
          });
          element.text = tempDiv.innerHTML;
        }
      })
    }
  }, [])
  const toggleGalleryPopup = (id, isGalleryPopupOpen, index = 0) => {
    setShowGalleryPopup({ [id]: isGalleryPopupOpen });
    setGalleryItemIndex(index);
  };
  const toggleSingleImagePopup = (id, isOpen) => {
    setShowSingleImagePopup({ [id]: isOpen });
  };
  const templates = {
    "also-read": AlsoRead
  };
  const goNext = () => {
    setGalleryItemIndex(galleryItemIndex + 1);
  };
  const goPrev = () => {
    setGalleryItemIndex(galleryItemIndex - 1);
  };
  const storyTemplate = story["story-template"];
  var cardWidth = "default-width";

  if (storyTemplate === "wau-juttu") {
    cardWidth = "default-width-wow";
    if (card.metadata.attributes) {
      if (card.metadata.attributes.kortinleveys && card.metadata.attributes.kortinleveys[0] !== undefined) {
        cardWidth = card.metadata.attributes.kortinleveys[0] + "-wow";
      }
    }
  } else if (storyTemplate !== "wau-juttu") {
    if (card.metadata.attributes) {
      if (card.metadata.attributes.kortinleveys && card.metadata.attributes.kortinleveys[0] !== undefined) {
        cardWidth = card.metadata.attributes.kortinleveys[0];
      }
    }
  }
  const getSlideshowElements = () => {
    const galleryItems = card["story-elements"].filter(
      item => item.type && item.type === "composite" && item.metadata && item.metadata.type === "slideshow"
    );
    if (galleryItems.length > 0) {
      return get(galleryItems, ["0", "story-elements"], []);
    }
    return [];
  };
  useEffect(() => {
    const slideshowItem = getSlideshowElements();
    setSlideshowItems(slideshowItem);
  }, []);
  return (
    <div styleName={cardWidth}>
      <div styleName="wrapper">
        {card["story-elements"].map((element, index) => {
          const lastIndex = element["story-elements"] && element["story-elements"].length - 1;
          switch (element.subtype) {
            case "image-gallery":
              if (element.metadata && element.metadata !== null && element.metadata.type === "gallery") {
                return (
                  <div key={index}>
                    {element.type === "composite" ? (
                      <ImageGalleryElement
                        story={story}
                        element={element}
                        key={element.id}
                        imageAspectRatio={[1, 1]}
                        imgParams={{ auto: ["format", "compress"], w: 400, dpr: 2.0 }}
                        onClickHandler={index => toggleGalleryPopup(element.id, true, index)}
                      />
                    ) : (
                      <StoryElement renderTemplates={templates} story={story} element={element} onClick={() => toggleSingleImagePopup(true)} />
                    )}
                    <div>
                      {showGalleryPopup[element.id] ? (
                        <LightBoxGallery
                          element={element["story-elements"][galleryItemIndex]}
                          goNext={() => goNext()}
                          goPrev={() => goPrev()}
                          index={galleryItemIndex}
                          hideNext={lastIndex === galleryItemIndex}
                          closePopup={() => toggleGalleryPopup(element.id, false)}
                        />
                      ) : null}
                    </div>
                  </div>
                );
              } else if (element.metadata && element.metadata.type === "slideshow" && slideshowItems.length) {
                return (
                  <div key={index}>
                    <GlideCarousel cardWidth={cardWidth} key={index} story={story} storyelements={element} cdnImage={cdnImage} />
                  </div>
                );
              }
              break;
            default:
              //Check if element is jsembed and and embed has flowplayer with padding-bottom > 100 (=portrait)
              let embedJs = "";
              let embedJsIsPortraitFlowplayer = false;
              if (element.type === "jsembed" && element["embed-js"] && element["embed-js"].length > 0) {
                embedJs = (element["embed-js"]);
                embedJsIsPortraitFlowplayer = checkEmbedCode(embedJs);
                if (embedJsIsPortraitFlowplayer) {
                  return (
                    <div styleName="portrait-flowplayer" key={index}>
                      <StoryElement renderTemplates={templates} story={story} element={element} />
                    </div>
                  )
                }
              }

              if (excludeElementId !== element.id) {
                return (
                  element.type === "image" ?
                    <div key={index} styleName="story-card-image">
                      <div className="story-element story-element-image">
                        {cardWidth === "tayslevea-wow" ?
                          <ResponsiveImage
                            slug={element["image-s3-key"]}
                            alt={element["image-atribution"]}
                            onClick={() => toggleSingleImagePopup(element.id, true)}
                          />
                          :
                          <figure styleName="img-style">
                            <LazyEagerImage
                              styleName="full-bleed-image"
                              togglePopImage={true}
                              src={`https://${cdnImage}/${element["image-s3-key"]}?w=980`}
                              togglePopImageFn={() => toggleSingleImagePopup(element.id, true)}
                            />
                          </figure>}
                        {(element.title || element["image-attribution"]) && (
                          cardWidth === "tayslevea-wow" ?
                            <div styleName="image-title-wrapper image-title-wrapper-tayslevea" className="voice-no-read">
                              {element.title && (
                                <figcaption styleName="img-figcap" className="story-element-image-title">
                                  {element.title}
                                </figcaption>
                              )}
                              {element["image-attribution"] && (
                                <figcaption styleName="img-figcap" className="story-element-image-title">
                                  Kuva: {element["image-attribution"]}
                                </figcaption>
                              )}
                            </div>
                            :
                            <div styleName="image-title-wrapper" className="voice-no-read">
                              {element.title && (
                                <figcaption styleName="img-figcap" className="story-element-image-title">
                                  {element.title}
                                </figcaption>
                              )}
                              {element["image-attribution"] && (
                                <figcaption styleName="img-figcap" className="story-element-image-title">
                                  Kuva: {element["image-attribution"]}
                                </figcaption>
                              )}
                            </div>)}
                      </div>
                      {showSingleImagePopup[element.id] && (
                        <LightBoxImage
                          element={element}
                          closePopup={() => toggleSingleImagePopup(element.id, false)}
                          isHeroImage={false}
                        />
                      )}
                    </div> :
                    <div key={index}>
                      <StoryElement renderTemplates={templates} story={story} element={element} />
                    </div>


                );
              } else {
                return null;
              }
          }
        })}
      </div>
    </div>
  );
};
StoryCard.propTypes = {
  card: object,
  story: object,
  excludeElementId: string,
  cdnImage: string
};

function mapStateToProps(state) {
  return {
    cdnImage: get(state, ["qt", "config", "cdn-image"])
  };
}

export default connect(mapStateToProps, () => ({}))(StoryCard);
